// extracted by mini-css-extract-plugin
export default {"button":"yEg7l","flexContainer":"CxTni","count":"mZT-M","switchCounterAndButton":"Fx0T7","srOnly":"WLQx-"};